module.exports = __webpack_public_path__ + "static/5-37743d43224626125e1c06f79cc2460b.jpg";